import React, { useState, useEffect } from 'react'; // Import useState from react
import './App.css';
import { BrowserRouter, Routes, Route, Link, NavLink } from 'react-router-dom';
import ItemListProyects from './pages/Proyect'; 
import ItemListEpics from './pages/Epic'; 
import ItemListStory from './pages/Story';  

import Signup from "./components/Signup";
import Login from './components/Login';
import Confirmation from './components/Confirmation';
import Dashboard from './pages/Dashboard';
import Proyects from './pages/Proyects';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Account } from './components/Account';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-YBVJD9ZV1V');

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Define isLoggedIn state here
  return (
            <DndProvider backend={HTML5Backend}>
              <Account>
                <BrowserRouter>
                  <main>
                    <Routes>
                      <Route path="/proyect/:proyectID" element={<ItemListProyects />} />
                      <Route path="/proyect/:proyectID/epic/:epicID" element={<ItemListEpics />} />
                      <Route path="/proyect/:proyectID/epic/:epicID/story/:storyID" element={<ItemListStory />} />
                      <Route path="/" element={<Signup />} />
                      <Route path="login" element={<Login />} />
                      <Route path="confirmation" element={<Confirmation />} />
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="proyects" element={<Proyects />} />
                    </Routes>
                  </main>
                </BrowserRouter>
              </Account>
            </DndProvider>
  );
}

export default App;
